import { Box, Typography } from "@mui/material";
import type { JSX } from "react";

export type HeaderMenuSectionTitleProps = {
  title: string;
};

export const HeaderMenuSectionTitle = ({ title }: HeaderMenuSectionTitleProps): JSX.Element => {
  return (
    <Box sx={{ p: "30px 0px 15px 0px" }}>
      <Typography variant="headerMenuSectionTitle">{title}</Typography>
    </Box>
  );
};
